import React, { useEffect, useState } from "react";
import {
  capitalizeWords,
  formatDateWithSuffix,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import {
  CalendarOutlined,
  ExclamationCircleOutlined,
  FieldTimeOutlined,
  ScheduleOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { Divider, Pagination, Table, Tag, Tooltip, Popover } from "antd";
// import { COLUMN_DATA, HEADER_DATA } from "./datafile";
import "./slantTableStyles.css";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import {
  CaAdminLearningMenu,
  LearningMatrixNav,
  // LearningRecordsNav,
} from "../../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import axiosInstance from "../../../../api/Axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const CourseLearningPlan = () => {
  const SessionColorIconWithColor = ({ state, color }) => {
    switch (state) {
      case "ongoing":
        return (
          <CalendarOutlined className="icon-testing" style={{ color: color }} />
        );
      case "scheduled":
        return (
          <FieldTimeOutlined
            className="icon-testing"
            style={{ color: color }}
          />
        );
      case "completed":
        return (
          <ScheduleOutlined className="icon-testing" style={{ color: color }} />
        );
      default:
        return (
          <ExclamationCircleOutlined
            className="icon-testing"
            style={{ color: color, fontSize: "13px" }}
          />
        );
    }
  };
  const history = useNavigate();
  const userInfo = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/learningemployeecoursematrix/?organization_id=${userInfo?.data?.organization?.id}`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, filter_url } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `&page_num=${currentPage}&page_size=${pageSize}&search=${search}${
          filter_url ? `&${filter_url}` : ""
        }`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page_num=${currentPage}&page_size=${pageSize}${
        filter_url ? `&${filter_url}` : ""
      }`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res?.data?.data?.data || []);
        setItemsLength(res.data?.data?.paginator?.count || 0);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const [dataC, setDataC] = useState([]);
  const [loadingC, setLoadingC] = useState(true);
  const [itemsLengthC, setItemsLengthC] = useState();
  const LoadUserC = async () => {
    let passUrl = `/learningmatrix/?organization_id=${userInfo?.data?.organization?.id}`;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `&page_num=${1}&page_size=${100}&search=${search}${
          filter_url ? `&${filter_url}` : ""
        }`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page_num=${1}&page_size=${100}${
        filter_url ? `&${filter_url}` : ""
      }`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setDataC(res?.data?.data?.data || []);
        setItemsLengthC(res.data?.data?.paginator?.count || 0);
        setLoadingC(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  useEffect(() => {
    LoadUserC();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const columns = [
    {
      title: "Learner Name",
      dataIndex: "full_name",
      key: "full_name",
      fixed: "left", // Keep the first column
      width: 180,
      render: (name, record) => {
        // Safeguard to ensure record.courses is a valid object
        const courses = record?.learningrecords || {};

        // Initialize counts for each status
        const statusCounts = {
          completed: 0,
          ongoing: 0,
          rejected: 0,
          scheduled: 0,
        };

        // Iterate over the courses to calculate counts
        Object.values(courses).forEach(({ state }) => {
          if (statusCounts[state.toLowerCase()] !== undefined) {
            statusCounts[state.toLowerCase()] += 1;
          }
        });

        // Return the user name along with status tags
        return (
          <div>
            <strong style={{ fontSize: "13.5px" }}>{name}</strong>
            <Divider
              style={{
                margin: "0px",
                padding: "0px",
                height: "2px",
                marginTop: "5px",
              }}
            />
            <div style={{ marginTop: "5px" }}>
              {Object.entries(statusCounts).map(([status, count]) => {
                if (count > 0) {
                  let backgroundColor = "";
                  switch (status) {
                    case "completed":
                      backgroundColor = "green"; // Light green
                      break;
                    case "ongoing":
                      backgroundColor = "blue"; // Light blue
                      break;
                    case "rejected":
                      backgroundColor = "red"; // Light red
                      break;
                    case "scheduled":
                      backgroundColor = "orange"; // Light orange
                      break;
                    default:
                      backgroundColor = "#E0E0E0"; // Light gray for undefined statuses
                  }

                  const text = `${count} ${status}`;
                  return (
                    <Tooltip title={text}>
                      <Tag
                        key={status}
                        style={{
                          // backgroundColor,
                          color: backgroundColor,
                          borderRadius: "8px",
                          padding: "0.5px 7px",
                          marginRight: "4px",
                          marginBottom: "2px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                      >
                        {count} {/* Only the count is displayed */}
                      </Tag>
                    </Tooltip>
                  );
                }
                return null;
              })}
            </div>
          </div>
        );
      },
    },
    ...dataC?.map((course) => ({
      title: (
        <Tooltip title={course?.name}>
          <div
            style={{
              minHeight: "160px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              maxWidth: "100px",
              position: "relative",
            }}
          >
            <div
              style={{
                transform: "rotate(-65deg)",
                transformOrigin: "bottom left",
                width: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textAlign: "left",
                fontSize: "14px",
                position: "absolute",
                bottom: 0,
                left: 0,
                fontWeight: "500",
              }}
            >
              {course?.name}
            </div>
          </div>
        </Tooltip>
      ),
      dataIndex: course,
      key: course,
      width: 100,
      align: "center",
      render: (_, record) => {
        const courseDetails = record.learningrecords?.find(
          (learningRecord) => learningRecord.course === course.id
        );

        if (!courseDetails) {
          return <div>--</div>;
        }

        const { state, completed_on, enrolled_on } = courseDetails;

        let backgroundColor = "";
        switch (state?.toLowerCase()) {
          case "completed":
            backgroundColor = "green";
            break;
          case "ongoing":
            backgroundColor = "#145da0";
            break;
          case "rejected":
            backgroundColor = "#E52B50";
            break;
          case "scheduled":
            backgroundColor = "#BF6900";
            break;
          default:
            backgroundColor = "#E0E0E0";
        }

        const enrolledDate = enrolled_on
          ? formatDateWithSuffix(enrolled_on)
          : "--";
        const completedDate =
          state?.toLowerCase() === "completed" && completed_on
            ? formatDateWithSuffix(completed_on)
            : null;

        const popoverContent = (
          <div style={{ minWidth: 220, lineHeight: 1.6 }}>
            <div>
              <span style={{ color: "#666666" }}>Course Name :</span>{" "}
              <span style={{ fontWeight: 500, color: "#black" }}>
                {course?.name || "--"}
              </span>
            </div>
            <div>
              <span style={{ color: "#666666" }}>Course ID :</span>{" "}
              <span style={{ fontWeight: 500, color: "black" }}>
                {course?.course_id || "--"}
              </span>
            </div>
            <div>
              <span style={{ color: "#666666" }}>State :</span>{" "}
              <span style={{ fontWeight: 500, color: "black" }}>
                {capitalizeWords(state) || "--"}
              </span>
            </div>
            <div>
              <span style={{ color: "#666666" }}>Enrolled On :</span>{" "}
              <span style={{ fontWeight: 500, color: "black" }}>
                {enrolledDate}
              </span>
            </div>
            {completedDate && (
              <div>
                <span style={{ color: "#666666" }}>Completed On :</span>{" "}
                <span style={{ fontWeight: 500, color: "black" }}>
                  {completedDate}
                </span>
              </div>
            )}
            <div style={{ marginTop: 4, textAlign: "right" }}>
              <span
                onClick={() =>
                  history(`/ca-admin/trainery-learn/courses/edit/${course?.id}`)
                }
                style={{
                  color: "#1890ff",
                  fontWeight: 500,
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                <LinkOutlined /> View Course
              </span>
            </div>
          </div>
        );

        return (
          <Popover
            content={popoverContent}
            // title="Course Details"
            trigger="hover"
          >
            <Tag
              style={{
                width: "60%",
                margin: "0 auto", // centers it horizontally
                borderRadius: "8px",
                padding: "6px 6px",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f9f9f9",
                border: `1px solid ${backgroundColor}`,
                color: backgroundColor,
                cursor: "pointer",
              }}
            >
              <SessionColorIconWithColor
                state={state?.toLowerCase()}
                color={backgroundColor}
              />
            </Tag>
          </Popover>
        );
      },
    })),
  ];
  return (
    <CaSideNav props={CaAdminLearningMenu}>
      <SecondaryNav menuItems={LearningMatrixNav} />
      <CommonTopDetails
        title={"Learner Course Matrix Summary"}
        titleSuffix={`Learners : ${itemsLength || 0} | Courses : ${
          itemsLengthC || 0
        }`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        marginPass="15px"
        showAddButton={false}
        filterAction={true}
        filterUrl={false}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: () => {},
        }}
        resetButtonProps={{
          modalProps: () => {},
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        // size="small"
        loading={loading || loadingC}
        bordered
        rowKey="id"
        className="modal-table-latest"
        scroll={{
          x: "max-content",
          y: `${remainingViewportHeight(40)}px`,
        }}
        style={{ marginInline: "1rem" }}
        pagination={false}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["10", "15", "30", "50", "100"]}
          showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </CaSideNav>
  );
};

export default CourseLearningPlan;
